import {
  IconDuotoneMail,
  IconFacebook,
  IconTelegram,
  IconTwitter,
} from '@heathmont/moon-assets';
import { rem } from '@heathmont/moon-utils';
import Img from '~/client/shared/images/Img';
import SimpleLink from '~/client/shared/SimpleLink';
import getCdnIcon from '~/shared/cdn/getCdnIcon';
import shareBlogPost from './shareBlogPost';
import SharePanel from './styles/SharePanel';
import useSocialLinks from './useSocialLinks';

type SocialLinksProps = {
  title: string;
};

const SocialLinks: FC<SocialLinksProps> = ({ title }) => {
  const { mailTo, url } = useSocialLinks({ title });
  return (
    <SharePanel space="small">
      <IconFacebook
        onClick={() => shareBlogPost({ url, shareTo: 'facebook' })}
        fontSize={rem(20)}
      />
      <IconTwitter
        onClick={() => shareBlogPost({ url, shareTo: 'twitter' })}
        fontSize={rem(20)}
      />
      <Img
        onClick={() => shareBlogPost({ url, shareTo: 'reddit' })}
        height={20}
        src={getCdnIcon('reddit')}
      />
      <IconTelegram
        onClick={() => shareBlogPost({ url, shareTo: 'telegram' })}
        fontSize={rem(20)}
      />
      <Img
        onClick={() =>
          shareBlogPost({ url, shareTo: 'wechat', options: { height: '500' } })
        }
        height={20}
        src={getCdnIcon('wechat')}
      />
      <SimpleLink href={mailTo} target="_top">
        <IconDuotoneMail fontSize={rem(20)} />
      </SimpleLink>
    </SharePanel>
  );
};

export default SocialLinks;
